import i18next from 'i18next';

export const getProcessList = () => {
  const processList = i18next.t('consultingPage.consultingProcessList', {
    returnObjects: true,
  }) as Array<{ number: number; label: string; description: string }>;

  return processList;
};
